import { ChevronLeftIcon } from '@heroicons/react/24/outline';
import { UserCircleIcon } from '@heroicons/react/24/solid';
import { inject, observer } from 'mobx-react';
import { Helmet } from 'react-helmet';
import { useLocation, useNavigate, useOutlet } from 'react-router-dom';
import MainBody from '../../Components/Body';
import Header from '../../Components/Header';
import MyProfilePage from './MyProfilePage';
import useLoadingLayoutMyProfile from './store';

const LayoutMyProfile = ({ store }) => {
  const { loading } = useLoadingLayoutMyProfile();
  const location = useLocation();
  const navigate = useNavigate();
  const outlet = useOutlet();
  const fromColor = () => {
    if (
      store.profile.status === 'active' ||
      store.profile.status === 'trialing'
    ) {
      if (store.profile.cancel_at_period_end) {
        return 'yellow-400';
      }
      return 'green-400';
    }
    return 'red-300';
  };

  const onBack = () => {
    navigate(`/my-profile`);
  };

  return (
    <div className="flex-1 flex flex-col overflow-auto">
      <Header
        title={store.profile.email}
        desc={`${store.profile.fname} ${store.profile.lname}`}
        category={store.profile.plan_description}
        tag={
          store.profile.status != 'trialing' ? store.profile.status : 'trial'
        }
        fromColorCategory={store.profile.plan_color}
        fromColorTag={fromColor()}
        Icon={UserCircleIcon}
        ppublic={true}
        profile={true}
        avatar={store.profile.avatar.svg}
        options={
          location.pathname !== '/my-profile'
            ? [
                {
                  title: 'Back to Profile',
                  Icon: ChevronLeftIcon,
                  onClick: onBack,
                },
              ]
            : null
        }
      >
        {location.pathname === '/my-profile' && (
          <Helmet>
            <title>{`My Profile - Straico`}</title>
          </Helmet>
        )}
      </Header>

      {loading ? (
        <div className="w-full -mt-[10px]">
          <progress className="progress progress-accent -mt-8"></progress>
        </div>
      ) : (
        <div className="w-full">
          <div className="flex h-[14px]"></div>
        </div>
      )}

      <MainBody className="pt-5 pb-4 py-2 md:px-28 flex-1 overflow-auto">
        <p className="text-right text-sm -mt-5 text-raisin-black dark:text-crystal-bell mr-4 font-figtree">
          Need assistance? Reach out to us at{' '}
          <span className="text-violet-blue">hello@straico.com</span>
        </p>
        {outlet}
      </MainBody>
    </div>
  );
};

export { MyProfilePage };

export default inject('store')(observer(LayoutMyProfile));
